<script>
    import { fade } from 'svelte/transition';

    export let message = '';
    export let duration = 3000;

    let visible = false;
    let timer;

    export function show(msg, ms = duration) {
        message = msg;
        visible = true;

        if (timer) clearTimeout(timer);
        timer = setTimeout(() => {
            visible = false;
        }, ms);
    }

    function hide() {
        visible = false;
        if (timer) clearTimeout(timer);
    }
</script>

{#if visible}
    <div class="toast" transition:fade={{ duration: 200 }}>
        {message}
    </div>
{/if}

<style>
    .toast {
        position: fixed;
        top: 35%;
        left: 50%;
        transform: translateX(-50%);
        width: fit-content;
        min-height: 120px;
        max-width: 5.5rem;
        word-wrap: break-word;
        padding: 24px 32px;
        background: #0b0b0d;
        border-radius: 40px;
        color: white;
        text-align: center;
        z-index: 9999;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
        pointer-events: none;
        font-size: 28px;
        color: #ffffff;
        line-height: 36px;
        font-family: DiDiSans-Pro-Medium;
    }
</style>
